import McSearchBarByTime from './McSearchBarByTime.vue'

McSearchBarByTime.install = function(Vue){
    Vue.component(McSearchBarByTime.name, McSearchBarByTime);
}

export default McSearchBarByTime;